import { render, staticRenderFns } from "./mobile_render.vue?vue&type=template&id=6ea0d2b8&scoped=true"
import script from "./mobile_render.vue?vue&type=script&lang=js"
export * from "./mobile_render.vue?vue&type=script&lang=js"
import style0 from "./mobile_render.vue?vue&type=style&index=0&id=6ea0d2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0d2b8",
  null
  
)

export default component.exports